import React from 'react';
import {isEmpty} from 'lodash';
import styled from 'styled-components';
import Utility from '../../../util/utilityfunctions';
import {labels, numberFormattedText} from '../../../util/utils';
import ShowMoreLess from './../../Common/ShowMoreLess/ShowMoreLess';
import ReactSlider from '../ReactSlider/ReactSlider';
import {useRef} from 'react';
import {formBodyType} from '../../../util/uiconstants';
import EllipsesMoment from '../EllipsesControl/EllipseMoment';
import CompareSnapshotLabel from '../CanvasForm/CompareSnapshotLabel';
import {useUserPreferences} from '../../../util/customHooks';

function TrackChangesComponent({changes}) {
	const reactSliderRef = useRef();
	const userPreferences = useUserPreferences();

	const selectedOptionsarray = [];
	changes &&
		changes.optionsAndResponses &&
		changes.optionsAndResponses
			.sort((a, b) => a.knowledgeDisplayOrder - b.knowledgeDisplayOrder)
			.map((option) => {
				if (option.bodySelectedOptionId) {
					selectedOptionsarray.push(option.bodyOptionText);
				}
			});

	const selectedOptions = selectedOptionsarray.join(' | ');

	const renderText = !isEmpty(selectedOptions)
		? selectedOptions
		: !isEmpty(changes.bodyFreeText)
		? changes.bodyFreeText
		: '';

	const formatedInnerText = Utility.getTrackChangesVersionText(renderText);
	const formatedRenderText = !isEmpty(formatedInnerText) ? formatedInnerText : labels.noResponseIdentified;

	const getDateContent = () => {
		if (Utility.isValidDate(formatedRenderText)) {
			return (
				<EllipsesMoment
					id="datePickerBodyDisplay"
					useFormat
					userPreferences={userPreferences}
					date={formatedRenderText}
					useLocal={false}
				/>
			);
		} else {
			return formatedRenderText;
		}
	};

	const getNumericContent = () => {
		let formatedText = numberFormattedText(
			userPreferences.numberFormat,
			formatedRenderText === null || !isNumeric(formatedRenderText) ? '' : formatedRenderText
		);
		if (formatedText === '') {
			formatedText = labels.noResponseIdentified;
		}
		return formatedText;
	};

	const getDecimalContent = () => {
		if (isNaN(parseFloat(formatedRenderText))) {
			return formatedRenderText;
		}
		const formatedText = (Math.round(formatedRenderText * 10) / 10).toString();
		return `${numberFormattedText(
			userPreferences.numberFormat,
			!formatedText || !isFinite(formatedText) ? '' : formatedText
		)}%`;
	};

	const isNumeric = (num) => {
		return !isNaN(num);
	};

	const sliderBodyHasAnyResponse = changes?.optionsAndResponses?.some((bodies) => {
		return bodies?.bodySelectedOptionId === 1;
	});

	const getReactSliderContent = (changes, bodyId) => {
		const bodySelectedOptionIds = changes?.optionsAndResponses?.find((bodies) => {
			return bodies?.bodySelectedOptionId === 1;
		});

		const sortedOptionsAndResponse = changes.optionsAndResponses.sort((a, b) => a.knowledgeDisplayOrder - b.knowledgeDisplayOrder);

		const defaultSelectValue =
			bodySelectedOptionIds === undefined
				? 0
				: bodySelectedOptionIds.bodySelectedOptionId === 1
				? {
						value: bodySelectedOptionIds.bodyOptionId,
						label: bodySelectedOptionIds.bodyOptionText,
						riskFactor: bodySelectedOptionIds.riskFactors
				  }
				: {
						value: 0,
						label: labels.select
				  };

		return (
			<ReactSlider
				max={sortedOptionsAndResponse[changes.optionsAndResponses.length - 1].bodyOptionId}
				min={sortedOptionsAndResponse[0].bodyOptionId}
				value={sortedOptionsAndResponse}
				defaultValue={defaultSelectValue}
				bodyId={bodyId}
				ref={reactSliderRef}
				StyleName={'ReactSliderBody'}
				aresSlider={true}
				disabled={true}
				isViewBodyOnly={false}
				isTrackChanges={true}
			/>
		);
	};

	const renderTrackChanges = (changes) => {
		switch (changes.bodyTypeId) {
			case formBodyType.Slider:
				return (
					<section className="trackChangesSliderContent">
						{sliderBodyHasAnyResponse ? (
							<>{getReactSliderContent(changes, changes.id)}</>
						) : (
							<ShowMoreLess>{formatedRenderText}</ShowMoreLess>
						)}
					</section>
				);
			case formBodyType.DatePicker:
				return <section className="trackChangesDateContent">{getDateContent()}</section>;
			case formBodyType.DecimalTextBox:
				return <section className="trackChangesDecimalContent">{getDecimalContent()}</section>;
			case formBodyType.NumericTextBox:
				return <section className="trackChangesNumericContent">{getNumericContent()}</section>;
			default:
				return selectedOptionsarray.length > 1 ? (
					<ShowMoreLess
						onClick={(e) => {
							e.stopPropagation();
						}}
					>
						<ul className="multiple-response-bullet">
							{selectedOptionsarray.map((option) => (
								<li>{option}</li>
							))}
						</ul>
					</ShowMoreLess>
				) : (
					<ShowMoreLess>{formatedRenderText}</ShowMoreLess>
				);
		}
	};

	const getClassName = (bodyId) => {
		return Object.keys(formBodyType)?.find((id) => formBodyType[id] === bodyId);
	};

	return (
		<StyledTrackChangesComponent className={`StyledTrackChangesComponent ${getClassName(changes.bodyTypeId)}`}>
			<section className={`trackChangesContentWrapper ${getClassName(changes.bodyTypeId)}`}>
				<section className="trackchanges-label">
					{labels.trackChangesResponseLabel}
					{':'}
				</section>
				{!isEmpty(renderText) && !changes.isAdded ? (
					renderTrackChanges(changes)
				) : (
					<section className="no-response-label">{labels.noResponseIdentified}</section>
				)}
			</section>
		</StyledTrackChangesComponent>
	);
}

export default TrackChangesComponent;

const StyledTrackChangesComponent = styled.section`
	background-color: var(--neutrals-25);
	padding: var(--px-16) var(--px-20);
	border-radius: var(--px-12);
	display: flex;
	.trackchanges-label {
		font-size: var(--px-16);
		font-weight: 700;
		font-style: italic;
		line-height: var(--px-24);
		color: var(--neutrals-700);
		margin-bottom: var(--px-12);
	}
	.richText-Body {
		font-size: var(--px-14);
		font-weight: 600;
		font-style: italic;
		line-height: var(--px-18);
		margin-bottom: 0 !important;
		color: var(--neutrals-700);
	}
	.no-response-label,
	.trackChangesDateContent {
		font-size: var(--px-14);
		font-weight: 600;
		font-style: italic;
		line-height: var(--px-18);
		color: var(--neutrals-700);
	}
	.multiple-response-bullet {
		padding-left: var(--px-20) !important;
	}
	.trackChangesContentWrapper {
		max-width: calc(100% - var(--px-110));
		.show-more-less {
			.richText-Body {
				.createRichTextElementSpanWrapper {
					* {
						font-weight: 600;
						font-style: italic;
						font-size: var(--px-16);
					}
				}
				.multiple-response-bullet {
					li {
						margin: 0;
						line-height: var(--px-24);
					}
				}
				&.collapsed {
					max-height: var(--px-120) !important;
				}
			}
		}
		.trackChangesDateContent {
			time {
				font-style: italic;
				font-weight: 600;
				font-size: var(--px-16);
				line-height: var(--px-18);
				color: var(--neutrals-700);
			}
		}
		.trackChangesDecimalContent,
		.trackChangesNumericContent {
			font-style: italic;
			font-weight: 600;
			font-size: var(--px-16);
			line-height: var(--px-18);
			color: var(--neutrals-700);
		}
	}
	.Slider {
		display: flex;
		width: 100%;
		.trackchanges-label {
			align-self: flex-end;
			width: calc(100% - var(--px-570));
		}
		.trackChangesSliderContent {
			width: var(--px-570);
			display: flex;
		}
		.ReactSliderBody {
			width: var(--px-500);
			.HandleToolTipWrapper {
				.TooltipWrapper {
					.railStyle {
						background-color: var(--neutrals-700);
						height: var(--px-2);
					}
				}
			}
			.slider-handles {
				.HandleWrapper {
					.handleContainer {
						.handleSlider {
							background-color: var(--neutrals-300);
						}
					}
				}
			}
			.slider-ticks {
				.tickSlider {
					background-color: var(--neutrals-700);
				}
				.tickSliderValue {
					.ellipses-multilines {
						span {
							font-size: var(--px-12);
							font-weight: 600;
							line-height: var(--px-16);
							font-style: italic;
							color: var(--neutrals-700);
						}
					}
				}
			}
		}
	}
	&.RadioButtonHorizontal {
		display: flex;
		.RadioButtonHorizontal {
			width: calc(100% - var(--px-100));
		}
	}
`;
